module.exports = __webpack_public_path__ + "static/media/doctor1.92f4f685.png";